module.exports = __webpack_public_path__ + "img/qualificacao-7.61b5c732.png";